import React, { useEffect, useState, useRef } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import MUIDataTable from 'mui-datatables';
import axios from 'axios';
import CircularProgress from "@mui/material/CircularProgress";


const TokenWiseReport = ({ openTokenWiseReport, dateFrom, dateTo, selectedRegionIds, changeRegionIds, reportUrl }) => {

    const baseUrl = localStorage.getItem('API_URL');
    const token = localStorage.getItem('user_token');
    const userDetails = JSON.parse(localStorage.getItem('user_details'));

    const [allreportsNew, setAllReportsNew] = useState([])
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [count, setCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    const timeoutRef = useRef(null);


    const [dataTable, setDataTable] = useState({
        page: 0,
        size: 10,
        search: '',
        order: null,
    });

    const setTable = (tableState) => {
        setDataTable({
            page: tableState.page,
            search: tableState.searchText,
            size: tableState.rowsPerPage,
            order: tableState.sortOrder
        });
    };

    // table for list view
    const columns = [
        {
            label: 'CLI',
            name: 'tokenId',
            options: {
                sort: true,
                filter: false,
                customBodyRender: (value) => (
                    <p style={{ margin: 0, width: '150px' }}>{value}</p>
                )
            }
        },
        {
            label: "Token Number",
            name: 'tokenNumber',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Date",
            name: 'date',
            options: {
                sort: true,
                filter: false,
                customBodyRender: (value) => (
                    <p style={{ margin: 0, width: '100px' }}>{value}</p>
                )
            }
        },
        {
            label: "Time",
            name: 'time',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Branch",
            name: 'branchName',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Region",
            name: 'regionName',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "User",
            name: 'userName',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Main Category",
            name: 'categoryName',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Sub Category",
            name: 'mainCategoryName',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Sub Sub Category",
            name: 'subSubCategoryName',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Language",
            name: 'language',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Waiting Time",
            name: 'waitTime',
            options: {
                sort: true,
                filter: false,
            }
        },
        {
            label: "Skill",
            name: 'skill',
            options: {
                sort: true,
                filter: false,
            }
        },


    ];

    const options = {
        // tableBodyHeight: '55vh',
        viewColumns: false,
        filterType: 'dropdown',
        filter: false,
        responsive: 'vertical',
        serverSide: true,
        count: count,
        download: false,
        jumpToPage: true,
        selectableRows: 'none',
        storageKey: '_twr_twr_table',
        print: false,
        rowsPerPage: rowsPerPage,
        rowsPerPageOptions: [10, 20, 30, 50, 100],
        setTableProps: () => {
            return {
                size: 'small',
            };
        },
        onTableChange: (action, tableState) => {

            // a developer could react to change on an action basis or
            // examine the state as a whole and do whatever they want

            switch (action) {
                case 'changePage':
                    getTokenWiseReport(tableState.page, tableState.sortOrder, tableState.searchText, tableState.rowsPerPage);
                    setTable(tableState);
                    break;
                case 'sort':
                    getTokenWiseReport(tableState.page, tableState.sortOrder, tableState.searchText, tableState.rowsPerPage);
                    setTable(tableState);
                    break;
                case 'changeRowsPerPage':
                    setRowsPerPage(tableState.rowsPerPage);
                    getTokenWiseReport(tableState.page, tableState.sortOrder, tableState.searchText, tableState.rowsPerPage);
                    setTable(tableState);
                    break;
                case 'search':
                    if (timeoutRef.current) {
                        clearTimeout(timeoutRef.current);
                    }
                    timeoutRef.current = setTimeout(() => getTokenWiseReport(tableState.page, tableState.sortOrder, tableState.searchText, tableState.rowsPerPage), 2000);
                    setTable(tableState);
                    break;
                default:
                    break;
            }
        },
    };


    // call getTokenWiseReport - useEffect
    useEffect(() => {
        if (openTokenWiseReport) {
            if (dateFrom.length > 0 && dateTo.length > 0) {
                getTokenWiseReport(0, null, null, rowsPerPage);
            }
        }
    }, [openTokenWiseReport, dateFrom, dateTo])

    // when change selected region array, call getTokenWiseReport - useEffect
    useEffect(() => {
        if (openTokenWiseReport) {
            getTokenWiseReport(0, null, null, rowsPerPage);
        }
    }, [changeRegionIds])



    //getTokenWiseReport - function
    const getTokenWiseReport = (page, sortOrder, search, size) => {
        setIsLoading(true);

        axios({
            method: 'POST',
            url: `${reportUrl}/real-time/token-wise-report/inner-data/customer/${userDetails.cid}`,
            headers: {
                Authorization: token
            },
            data: {
                "page": page,
                "size": size,
                "dateFrom": dateFrom,
                "dateTo": dateTo,
                "sort": sortOrder,
                "searchText": search,
                branchIds: selectedRegionIds
            }

        }).then((res) => {

            let data = res.data.data;
            setAllReportsNew((data.content))
            setCount(data.totalElements);

            setIsLoading(false);

        }).catch((error) => {
            console.log(error);
            setIsLoading(false);
            if (error.response !== undefined) {
                toast.error(error.response.data.message, {
                    position: 'bottom-center',
                });
            } else {
                toast.remove();
                toast.error('Something went wrong', {
                    position: 'bottom-center',
                });
            }
        })
    }

    return (
        <>
            <div><ToastContainer /></div>

            <MUIDataTable

                title={
                    <>
                        {isLoading ?
                            <CircularProgress color="secondary" size={20} /> : <>{count} records.</>}
                    </>
                }
                data={allreportsNew}
                columns={columns}
                options={options}
                className='text-center-table'
            />

        </>
    )
}

export default TokenWiseReport
